import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBurFujTg8qABfru5w8fEGxEYCZ-6uok-o",
  authDomain: "prepgrid-7d.firebaseapp.com",
  projectId: "prepgrid-7d",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);